import { useEffect, useState } from "react";
// import VerAnexosLista from "./VerAnexosLista.jsx";
import { Alert, Divider } from "@mui/material";
import TablaDesarrollo from "./TablaDesarrollo.jsx";
import Card from "react-bootstrap/Card";
import AlertTitle from "@mui/material/AlertTitle";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import EmojiObjectsIcon from "@mui/icons-material/EmojiObjects";
import { sql } from "../componentes/api.js";
import Anexos from "./Anexos.jsx";

const SegParticipante = (props) => {
  /**Para cargar los datos de los combos */
  const [cargando, setCargando] = useState(false);
  const [participantes, setParticipantes] = useState([]);
  const [idParticipante, setIdParticipante] = useState("");
  const [idActividad, setIdActividad] = useState("");
  const [idProyectoActividad, setIdProyectoActividad] = useState();
  const [actividadesProyecto, setActividadesProyecto] = useState([]);
  const [requiereAnexo, setRequiereAnexo] = useState(0);
  const [cant, setCant] = useState(0);
  const [conexiones, setConexiones] = useState({
    NumIngresos: 0,
    HoraIngreso: "",
    HoraFinal: "",
  });

  useEffect(() => {
    if (props.idProyecto !== "") {
      cargarParticipantes();
      setActividadesProyecto([]);
      setParticipantes([]);
    }
  }, [props.idProyecto, props.tipoParticipante]);

  const asignarDato = (event) => {
    event.preventDefault();
    console.log("llego");
    console.log(event.target.name, event.target.value);
    setActividadesProyecto([]);
    setIdParticipante(event.target.value);
    cargarProyectoActividad(0, event.target.value);
  };

  const cargarParticipantes = async () => {
    try {
      const response = await sql("getParticipantes", "POST", {
        idProyecto: props.idProyecto,
        idAuditor: props.id,
        tipoParticipante: props.tipoParticipante,
      });
      setParticipantes(response);
    } catch (error) {
      props.mostrarMsg([
        "ERROR",
        "Ocurrio un error al cargar los Participantes",
        error,
      ]);
    }
  };

  const cargarProyectoActividad = async (filtro, idParticipante) => {
    /*** Primero busco cuando fue su última conexión y cuantas ha realizado ***/
    try {
      const con = await sql("getConexiones", "POST", { Id: idParticipante });
      setConexiones(con[0]);

      /*** Ahora busco las actividades  ****/
      const response = await sql("getProyectoActividad", "POST", {
        idProyecto: props.idProyecto,
        tipoParticipante: props.tipoParticipante,
        idParticipante: idParticipante,
        idCargo: props.idCargo,
        filtro: filtro,
      });
      setCant(response.length);
      if (response.length !== 0 && response.length !== "0")
        setActividadesProyecto(response);
      else setActividadesProyecto([]);
    } catch (error) {
      props.mostrarMsg([
        "ERROR",
        "Ocurrio un error al cargar las Actividades del Proyecto",
        error,
      ]);
    }
  };

  const filtrar = (event) => {
    event.preventDefault();
    if (idParticipante !== "")
      cargarProyectoActividad(event.target.value, idParticipante);
    else props.mostrarMsg(["Por favor seleccione un Participante"]);
  };

  const mostrarTabla = (idProyectoActividad, AnexosRequeridosMes) => {
    return (
      <TablaDesarrollo
        idProyectoActividad={idProyectoActividad}
        idParticipante={idParticipante}
        idUsuario={props.id}
        auditor={true}
        anexosRequeridos={AnexosRequeridosMes}
        tipoParticipante={props.tipoParticipante}
      />
    );
  };

  return (
    <div className="container-fluid">
      <div className="row card mt-3 mb-3">
        <Alert severity="success">
          <strong>
            SEGUIMIENTO A LAS ACTIVIDADES DE PARTICIPANTES (BENEFICIARIOS)
          </strong>
        </Alert>

        <div className="row mt-3 mx-0">
          <div className="row form-floating mb-3">
            <div className="col-sm-6">
              <label htmlFor="idBeneficirio">
                Participante (Beneficiarios)
              </label>
              <select
                type="text"
                className="form-control"
                name="idParticipante"
                value={idParticipante}
                onChange={(event) => {
                  asignarDato(event);
                }}
              >
                <option key="0" value="0">
                  Por favor seleccione un Beneficiario...
                </option>
                {participantes.map((reg, i) => {
                  return (
                    <option key={i} value={reg.Id} label={reg.Nbres}>
                      {" "}
                      {reg.Nbres}{" "}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className="col-sm-6">
              <div className="shadow-lg p-3 mb-2 bg-body-tertiary rounded">
                <div>
                  Ultima conexión: <strong>{conexiones.HoraFinal}</strong>
                </div>
                <div>
                  Número total de conexiones:{" "}
                  <strong>{conexiones.NumIngresos}</strong>{" "}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <Alert severity="info">
            <AlertTitle>
              <strong>FILTRE LAS ACTIVIDADES QUE DESEA VER</strong>
            </AlertTitle>
            <br />
            <div
              className="btn-group"
              role="group"
              aria-label="Basic mixed styles example"
            >
              <button
                type="button"
                className="btn btn-dark"
                value={0}
                onClick={filtrar}
              >
                Todos
              </button>
              <button
                type="button"
                className="btn btn-danger"
                value={1}
                onClick={filtrar}
              >
                Pendientes
              </button>
              <button
                type="button"
                className="btn btn-warning"
                value={2}
                onClick={filtrar}
              >
                Para Revisión
              </button>
              <button
                type="button"
                className="btn btn-success"
                value={3}
                onClick={filtrar}
              >
                Devueltas
              </button>
              <button
                type="button"
                className="btn btn-primary"
                value={4}
                onClick={filtrar}
              >
                Con Visto Bueno
              </button>
            </div>
            <div className="form-text">
              Cantidad de Actividades encontradas {cant}
            </div>
            {cargando === true && (
              <div className="spinner-grow text-primary" role="status"></div>
            )}
          </Alert>
        </div>

        {/* {actividadesProyecto.toString().length > 0 && actividadesProyecto.map((reg, i)=>{ */}
        {actividadesProyecto.map((reg, i) => {
          return (
            <div className="row" key={i}>
              <Card>
                <Card.Body>
                  <Card.Title>
                    {i + 1}. {reg.Nbre}
                  </Card.Title>
                  <Card.Subtitle className="mb-2 text-muted">
                    {reg.TipoProyecto}
                  </Card.Subtitle>

                  <Card.Subtitle className="mb-2 text-muted mb-3 mt-3">
                    <CalendarMonthIcon /> Actividad para realizarse desde el{" "}
                    {reg.FechaIni.toString().substring(0, 10)} al{" "}
                    {reg.FechaFin.toString().substring(0, 10)}
                  </Card.Subtitle>

                  {/* Zona para mirar los anexos de guías */}
                  {reg.TieneAnexos === 1 && (
                    <blockquote className="blockquote mb-0">
                      <p>
                        {" "}
                        <EmojiObjectsIcon /> Esta actividad contiene archivos
                        guías{" "}
                      </p>
                      <Anexos
                        Proyecto={props.idProyecto}
                        Actividad={reg.IdActividad}
                        llamador={props.tipoParticipante}
                      />
                    </blockquote>
                  )}

                  <Divider className="mb-3 mt-3" />
                  {/* zona para adjuntar los anexos requeridos */}
                  {reg.AnexosRequeridosMes > 0 ? (
                    <div className="row mt-3">
                      {mostrarTabla(reg.Id, reg.AnexosRequeridosMes)}
                    </div>
                  ) : (
                    <Alert severity="success">
                      No requiere anexar archivos para esta Actividad!
                    </Alert>
                  )}
                </Card.Body>
              </Card>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SegParticipante;
